import { ScrollingCarousel } from "@trendyol-js/react-carousel";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./Carousel.scss";
import { Skeleton } from "antd";

interface CarouselProps {
  visibleItems: number;
  loading?: boolean;
}
const Carousael: React.FC<CarouselProps> = (props) => {
  const { loading, children, keyProp }: any = props;

  function makeid(length: number) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  if (loading) return <Skeleton active />;

  if (!children || children.length === 0) return null;
  return (
    <div className="carousel" key={!keyProp ? makeid(10) : keyProp}>
      <div className="carousel-container" style={{ width: "100%" }}>
        <ScrollingCarousel
          leftIcon={
            <div className="arrow">
              <LeftOutlined />
            </div>
          }
          rightIcon={
            <div className="arrow">
              <RightOutlined />
            </div>
          }
        >
          {children}
        </ScrollingCarousel>
      </div>
    </div>
  );
};

export default Carousael;
